import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Route, Switch} from "react-router-dom";
import PropTypes from 'prop-types';

import Drawer from "../components/Drawer/drawer";
import Header from "../components/Header";
import {
  MyChannels,
  ChannelStore,
  AllUnits,
  Unit,
  ChannelDashboard,
  Store
} from "../containers/application";
import {signOut} from "../containers/auth/redux_actions"
import {toggleDrawer} from "../containers/application/redux_actions";
import "./_application.css"

const defaultTop = <div><div>Contributor Development Support</div><div style={{fontSize:"0.8rem", fontWeight:"normal"}}>Course enablers for facilitators</div></div>;

class Application extends Component {

  render() {
    let {url} = this.props.match;
    let {drawerOpen} = this.props.app;
    return (
      <div id="application-cntr">
        <Header
          toggleDrawer=
          {()=>{this.props.toggleDrawer()}}
          pagetitle={getPageHeaders[this.props.location.pathname] || defaultTop}
          signOut={this.props.signOut}
          />
        <Drawer state={drawerOpen} toggleDrawer= {()=>{this.props.toggleDrawer()}}/>
        <div id="app-body">
          <Switch>
            <Route path={url + "/channelStore"} component={ChannelStore}/>
            <Route path={url + "/myChannels"} component={MyChannels}/>
            <Route
              path={url + "/channelDashboard/:channelId"}
              component={ChannelDashboard}/>
            <Route path={url + "/allUnits"} component={AllUnits}/>
            <Route path={url + "/unit/:unitId"} component={Unit}/>
            <Route path={url + "/store"} component={Store}/>
            <Route path={url + "/"} component={MyChannels}/>
          </Switch>
        </div>
      </div>
    );
  }
}

Application.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired
};

const getPageHeaders = {
  "/application": defaultTop,
  "/myChannels": "My Channels",
}

const mapStateToProps = state => ({app: state.app});

function matchDispatchToProps(dispatch) {
  return bindActionCreators({
    toggleDrawer, signOut
  }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Application);



// WEBPACK FOOTER //
// ./src/routes/Application.js